export const APPLICATION_HISTORY_FETCHING = 'APPLICATION_HISTORY_FETCHING';
export const APPLICATION_HISTORY_FETCH_DATA = 'APPLICATION_HISTORY_FETCH_DATA';
export const APPLICATION_HISTORY_FETCH_APP_DATA =
  'APPLICATION_HISTORY_FETCH_APP_DATA';
export const APPLICATION_HISTORY_FETCH_ERROR =
  'APPLICATION_HISTORY_FETCH_ERROR';



// WEBPACK FOOTER //
// ./src/pages/manageapplication/state/applicationhistory/types.js